/* eslint-disable @typescript-eslint/no-explicit-any */
import Select, { StylesConfig } from 'react-select'
import chroma from 'chroma-js'
import { useSelector } from 'react-redux'
import { selectUser } from '../../reducers/users'

interface IDropDownProps {
  options: any
  value: any
  onChangeHandler: (newValue: any) => void
  style: string
  placeholder: string
  multiple: boolean
  disabled: boolean
  height?: string
  menuPortalTarget?: HTMLElement
}

function DropDown(props: IDropDownProps) {
  const {
    options,
    value,
    onChangeHandler,
    style,
    placeholder,
    multiple,
    disabled,
    height = '38px',
    menuPortalTarget,
  } = props
  const { darkModeEnabled } = useSelector(selectUser)

  const colourStyles: StylesConfig<any, true> = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),

    multiValue: (styles, { data }) => {
      const bgColor = darkModeEnabled ? data.bgColor.dark : data.bgColor.light
      return {
        ...styles,
        backgroundColor: chroma(bgColor).css(),
      }
    },

    multiValueLabel: (styles, { data }) => {
      const textColor = darkModeEnabled ? data.color.dark : data.color.light
      return {
        ...styles,
        color: textColor,
        fontSize: '14px',
      }
    },

    multiValueRemove: (styles, { data }) => {
      const textColor = darkModeEnabled ? data.color.dark : data.color.light
      return {
        ...styles,
        color: textColor,
        ':hover': {
          backgroundColor: textColor,
          color: 'white',
        },
      }
    },
  }

  const customStyles = {
    control: (base: any, state: any) => ({
      ...base,
      height: height,
      minHeight: '38px',
      backgroundColor: darkModeEnabled ? '#292828' : '#fff',
      borderColor: darkModeEnabled ? '#555' : '#ccc',
      color: darkModeEnabled ? '#fff' : '#000',
      boxShadow: state.isFocused ? (darkModeEnabled ? '0 0 0 2px #6958ad' : '0 0 0 2px #aa99ec') : undefined,
      '&:hover': {
        borderColor: state.isFocused ? 'transparent' : '#aa99ec',
        cursor: 'pointer',
      },
      opacity: disabled ? 0.5 : 1,
    }),
    valueContainer: (base: any) => ({
      ...base,
      paddingTop: '0px',
      paddingBottom: '0px',
      fontSize: '14px',
    }),
    placeholder: (base: any) => ({
      ...base,
      paddingTop: '0px',
      color: darkModeEnabled ? '#aaa' : '#555',
    }),
    singleValue: (base: any) => ({
      ...base,
      color: darkModeEnabled ? '#fff' : '#000',
    }),
    input: (base: any) => ({
      ...base,
      height: '36px',
      minHeight: '36px',
      marginTop: '0px',
      marginBottom: '0px',
      paddingTop: '0px',
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: darkModeEnabled ? '#333' : '#fff',
      color: darkModeEnabled ? '#fff' : '#000',
    }),
    option: (base: any, { isFocused, isSelected }: { isFocused: boolean; isSelected: boolean }) => ({
      ...base,
      backgroundColor: isSelected
        ? darkModeEnabled
          ? '#444'
          : '#ddd'
        : isFocused
          ? darkModeEnabled
            ? '#555'
            : '#eee'
          : 'transparent',
      color: darkModeEnabled ? '#fff' : '#000',
    }),
  }

  return (
    <Select
      value={value}
      onChange={(e: any) => onChangeHandler(e)}
      options={options}
      className={`${style} leading-normal not-form-styled`}
      placeholder={placeholder}
      styles={{ ...colourStyles, ...customStyles }}
      isMulti={multiple ? true : undefined}
      isDisabled={disabled ? true : undefined}
      menuPortalTarget={menuPortalTarget}
    />
  )
}

export default DropDown
